import { createSlice } from '@reduxjs/toolkit';
import { extractSharedActions } from '@sda/utils/store';
import { Reducers } from '@sda/enums/store';
import { createEntityAdapter } from '@client/store/entity.adapter';
import type { EmailTemplate } from '@sda/interfaces/setting/emailtemplate';
import type { FetchDataType } from '@sda/sdk/interfaces';

export const emailTemplateAdapter = createEntityAdapter<EmailTemplate & FetchDataType>();

const emailTemplatesSlice = createSlice({
  initialState: emailTemplateAdapter.getInitialState(),
  name: Reducers.EMAIL_TEMPLATES,
  reducers: {
    ...extractSharedActions(emailTemplateAdapter),
  },
});

export default emailTemplatesSlice.reducer;
